import { createAsyncThunk } from '@reduxjs/toolkit'
import {
    ClubSubUserListApi,
    ClubSubUserByIdApi,
    ClubSubUserCreateApi,
    ClubSubUserDeleteApi,
    ClubSubUserUpdateApi,
    AllSubMemberListApi
} from './ClubSubUser.services'
import { paginationData } from '../Pagination/reducers'

//services
export const ClubSubUserList = createAsyncThunk(
    'ClubSubUser/list',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await ClubSubUserListApi(data)

            if (data._limit) {
                // Pagination Section
                const limit = data._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const AllSubMemberList = createAsyncThunk(
    'ClubSubUser/allSubMemberlist',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await AllSubMemberListApi(data)

            if (data._limit) {
                // Pagination Section
                const limit = data._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

//
export const ClubSubUserCreate = createAsyncThunk(
    'ClubSubUser/create',
    async (data, { rejectWithValue }) => {
        try {
            const res = await ClubSubUserCreateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

//
export const ClubSubUserUpdate = createAsyncThunk(
    'ClubSubUser/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await ClubSubUserUpdateApi(data.age_classification_id, data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

//
export const ClubSubUserById = createAsyncThunk(
    'ClubSubUser/one',
    async (ID, { rejectWithValue }) => {
        try {
            const res = await ClubSubUserByIdApi(ID)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

//
export const ClubSubUserDelete = createAsyncThunk(
    'ClubSubUser/delete',
    async (ID, { rejectWithValue }) => {
        try {
            const res = await ClubSubUserDeleteApi(ID)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
